export default __webpack_public_path__ + "static/media/bu2.39d5e399.jpg";